<script lang="ts">
    import Auth from "../components/Auth.svelte";

    export let qs;

    qs.action = qs.action || "register"
    if (!["login", "register"].includes(qs.action)) qs.action = "register"
</script>

<h1 class="w3-center text-3xl w-full text-center">Welcome to Persu<span style="font-family: monospace;">AI</span>d
</h1>
<p class="w-full text-xl text-center">
    An assisted copywriting editor.
</p>
<Auth authMode={qs.action} on:auth={() => window.location.href=qs.next || "/"} />
